var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 0 C 20.187 0 0 20.187 0 45 c 0 24.813 20.187 45 45 45 c 24.813 0 45 -20.187 45 -45 C 90 20.187 69.813 0 45 0 z M 48 31.559 c 4.885 -0.239 9.636 -1.059 14.088 -2.403 C 62.971 33.151 63.535 37.48 63.71 42 H 48 V 31.559 z M 48 25.551 V 6.53 c 5.139 1.8 9.651 8.111 12.517 16.84 C 56.579 24.572 52.358 25.316 48 25.551 z M 42 6.53 v 19.021 c -4.358 -0.235 -8.579 -0.978 -12.517 -2.18 C 32.349 14.641 36.861 8.33 42 6.53 z M 42 31.559 V 42 H 26.29 c 0.175 -4.52 0.739 -8.849 1.622 -12.843 C 32.364 30.5 37.115 31.32 42 31.559 z M 20.284 42 H 6.127 c 0.565 -7.39 3.195 -14.208 7.318 -19.879 c 2.652 1.924 5.591 3.59 8.758 4.959 C 21.131 31.684 20.468 36.704 20.284 42 z M 20.284 48 c 0.184 5.296 0.847 10.317 1.919 14.921 c -3.167 1.369 -6.106 3.035 -8.758 4.959 C 9.322 62.208 6.692 55.39 6.127 48 H 20.284 z M 26.29 48 H 42 v 10.441 c -4.885 0.239 -9.636 1.059 -14.087 2.403 C 27.029 56.85 26.465 52.52 26.29 48 z M 42 64.45 v 19.02 c -5.139 -1.8 -9.65 -8.111 -12.517 -16.84 C 33.421 65.428 37.642 64.685 42 64.45 z M 48 83.47 V 64.45 c 4.358 0.235 8.579 0.978 12.517 2.18 C 57.651 75.359 53.139 81.67 48 83.47 z M 48 58.441 V 48 h 15.71 c -0.175 4.52 -0.739 8.85 -1.623 12.844 C 57.636 59.5 52.886 58.68 48 58.441 z M 69.716 48 h 14.157 c -0.565 7.39 -3.195 14.208 -7.318 19.879 c -2.652 -1.924 -5.591 -3.589 -8.758 -4.959 C 68.87 58.317 69.533 53.296 69.716 48 z M 69.716 42 c -0.184 -5.296 -0.847 -10.316 -1.919 -14.921 c 3.167 -1.369 6.106 -3.035 8.758 -4.959 C 80.679 27.792 83.308 34.61 83.873 42 H 69.716 z M 72.66 17.536 c -1.993 1.409 -4.176 2.65 -6.51 3.712 c -1.596 -4.749 -3.665 -8.889 -6.098 -12.223 C 64.804 11.02 69.08 13.931 72.66 17.536 z M 29.949 9.024 c -2.433 3.334 -4.502 7.475 -6.098 12.224 c -2.335 -1.062 -4.518 -2.302 -6.511 -3.712 C 20.92 13.931 25.196 11.02 29.949 9.024 z M 17.34 72.464 c 1.993 -1.409 4.176 -2.65 6.511 -3.712 c 1.596 4.749 3.666 8.889 6.098 12.224 C 25.196 78.98 20.92 76.069 17.34 72.464 z M 60.051 80.976 c 2.433 -3.334 4.502 -7.474 6.098 -12.223 c 2.334 1.062 4.517 2.302 6.51 3.712 C 69.08 76.069 64.804 78.98 60.051 80.976 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#231665",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.b81ecd83bcd863ebacf002052f220273.svg";
export { ForwardRef as ReactComponent };